import { render, staticRenderFns } from "./CollageManagement.vue?vue&type=template&id=bf178168&"
import script from "./CollageManagement.vue?vue&type=script&lang=js&"
export * from "./CollageManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports